export default __webpack_public_path__ + "static/media/hht1_ep6_minisitcom_04.222301f1.png";